import React from "react";
import { Search, Phone, UserPlus } from "lucide-react";
import { ChannelIcon } from "./iconesCanais";
import { CORES, CONVERSAS, corDoNome, iniciais, preview } from "./dadosMockup";

// Abas reais do chat: Andamento / Espera / Automações (novochat.json chat.tabs).
const ABAS = [
  { rotulo: "Andamento", ativa: true, contador: 6 },
  { rotulo: "Espera", contador: 2 },
  { rotulo: "Automações" },
];

export function AvatarIniciais({ nome, tamanho = 40, className = "" }) {
  return (
    <div
      className={`rounded-full flex items-center justify-center font-bold text-white shrink-0 ${className}`}
      style={{
        width: tamanho,
        height: tamanho,
        background: corDoNome(nome),
        fontSize: tamanho * 0.36,
        border: `1px solid ${CORES.borda}`,
        boxShadow: "0 10px 15px -3px rgba(0,0,0,0.3)",
      }}
    >
      {iniciais(nome)}
    </div>
  );
}

export function AbasAtendimento({ compacta = false }) {
  return (
    <div className="flex p-1 rounded-full shadow-inner" style={{ background: CORES.muted }}>
      {ABAS.map((aba) => (
        <div
          key={aba.rotulo}
          className={`relative flex-1 text-center font-medium rounded-full whitespace-nowrap ${compacta ? "py-2 text-[11px]" : "py-3 text-[13px]"}`}
          style={
            aba.ativa
              ? { background: CORES.azulAtivo, color: "#fff", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.3)" }
              : { color: CORES.textoMuted }
          }
        >
          {aba.rotulo}
          {aba.contador ? (
            <span
              className="absolute -top-1 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold text-white flex items-center justify-center"
              style={{ background: CORES.vermelhoContador }}
            >
              {aba.contador}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
}

export function LinhaBusca({ compacta = false }) {
  const botao = compacta ? "w-8 h-8" : "w-9 h-9";
  return (
    <div className="flex items-center gap-2">
      <div
        className={`flex-1 flex items-center gap-2 px-3 rounded-md ${compacta ? "h-8" : "h-9"}`}
        style={{ background: "rgba(23,23,23,0.5)", border: `1px solid ${CORES.borda}` }}
      >
        <Search className="w-4 h-4" style={{ color: CORES.textoMuted }} />
        <span className="text-sm" style={{ color: CORES.textoMuted }}>Buscar</span>
      </div>
      <div className={`${botao} rounded-md flex items-center justify-center`} style={{ background: CORES.muted }}>
        <Phone className="w-4 h-4" style={{ color: CORES.textoMuted }} />
      </div>
      <div className={`${botao} rounded-md flex items-center justify-center`} style={{ background: CORES.azulAtivo }}>
        <UserPlus className="w-4 h-4 text-white" />
      </div>
    </div>
  );
}

export function ItemConversa({ conversa, compacta = false }) {
  const { nome, canal, msg, hora, naoLidas, ativo } = conversa;
  return (
    <div
      className={`relative flex items-center gap-3 rounded-xl ${compacta ? "h-16 px-3" : "h-20 px-[0.8rem]"}`}
      style={{
        background: ativo ? `linear-gradient(to right, ${CORES.fundo}, ${CORES.card})` : CORES.card,
        border: `1px solid ${ativo ? CORES.outlineAtivo : CORES.borda}`,
        boxShadow: ativo ? `inset 0 0 0 1px ${CORES.outlineAtivo}` : undefined,
      }}
    >
      {ativo && (
        <span className="absolute left-0 top-2 bottom-2 w-1 rounded-r-full" style={{ background: CORES.primary }} />
      )}
      <div className="relative">
        <AvatarIniciais nome={nome} tamanho={compacta ? 36 : 40} />
        <span
          className="absolute -bottom-1 -right-1 rounded-full p-0.5 flex"
          style={{ background: CORES.card, border: `1px solid ${CORES.borda}` }}
        >
          <ChannelIcon canal={canal} className="w-3 h-3" />
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="font-bold tracking-wide truncate text-[13px]" style={{ color: CORES.texto }}>
            {nome}
          </span>
          <span className="text-[10px] font-medium shrink-0" style={{ color: CORES.textoMuted }}>
            {hora}
          </span>
        </div>
        <div className="flex items-center justify-between gap-2 mt-0.5">
          <span className="text-xs truncate" style={{ color: CORES.textoMuted }}>
            {preview(msg)}
          </span>
          {naoLidas ? (
            <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
              {naoLidas}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default function ListaConversas() {
  return (
    <div className="flex flex-col h-full gap-4 p-4 pb-0" style={{ background: CORES.card }}>
      <AbasAtendimento />
      <LinhaBusca />
      <div className="h-px" style={{ background: CORES.muted }} />
      <div className="flex flex-col gap-1 pl-3 pr-4 -mx-1 overflow-hidden">
        {CONVERSAS.map((c) => (
          <ItemConversa key={c.nome} conversa={c} />
        ))}
      </div>
    </div>
  );
}
